<footer class="apt-container text-light font-maxis-semibold footer">
  <div class="apt-grid">
    <div class="mb-3 font-maxis-light footer-1">
      <p class="line-height mb-1">
        <small>{{priceStated}}</small>
        </p>
      <p class="line-height mb-1">
        <small>{{redressYourComplaints}}</small>
        </p>
    </div>
    <div class="mb-3 font-maxis-light footer-2">
      <p class="line-height">
        <small>{{maxisCopyright}}</small>
      </p>
    </div>
  </div>  
</footer>